import {
  ChangeProcessPlaceRequest,
  ChangeProcessPlaceRequestToJSON,
  HTTPBody
} from '@/api'
import * as runtime from '../runtime'

export class PlaceChangeApi extends runtime.BaseAPI {
  /**
   * 処理場所を変更する
   * 処理場所変更
   */
  async changeProcessPlace(
    request: ChangeProcessPlaceRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = ChangeProcessPlaceRequestToJSON(request)

    const response = await this.requestPost('/place-change', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
